// removed by extract-text-webpack-plugin
module.exports = {"header":"_1ULqj","sources":"_3iSMg","primLead":"jhHQl","primHeader":"_3P-vv","winnerHeaders":"_2Wl-b","winnerHeader":"_1lS-O"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App.scss
 ** module id = 112
 ** module chunks = 0
 **/